import { render } from "./WorkHistory.vue?vue&type=template&id=21f9d1a1&scoped=true"
import script from "./WorkHistory.vue?vue&type=script&lang=js"
export * from "./WorkHistory.vue?vue&type=script&lang=js"

import "./WorkHistory.vue?vue&type=style&index=0&id=21f9d1a1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21f9d1a1"

export default script